import { VisibilityOutlined } from '@mui/icons-material';
import { Box, Button, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import type { SessionContextDescriptor } from './navigation';
import { designTokens } from './tokens';
import { createFocusRingStyles } from './interaction';

export function SessionContextDock({ context, compact = false }: { context: SessionContextDescriptor; compact?: boolean }) {
  if (compact) {
    return <Tooltip title={[context.label, context.description, context.actionLabel].filter(Boolean).join(' · ')} arrow>
      <IconButton
        aria-label={`${context.label}. ${context.actionLabel}`}
        disabled={context.actionDisabled}
        onClick={context.onAction}
        sx={{ color: designTokens.color.warning, border: 1, borderColor: designTokens.color.warning, bgcolor: designTokens.color.canvas, '&:hover': { bgcolor: designTokens.color.navigationSurface } }}
      >
        <VisibilityOutlined />
      </IconButton>
    </Tooltip>;
  }

  return <Box
    role="status"
    aria-live="polite"
    sx={{ width: 400, minHeight: 38, [designTokens.media.touchTarget]: { minHeight: designTokens.layout.touchTargetMinSize }, minWidth: 0, px: 1.25, border: 1, borderColor: designTokens.color.warning, borderRadius: designTokens.radius.pill, bgcolor: designTokens.color.canvas, display: 'flex', alignItems: 'center' }}
  >
    <VisibilityOutlined aria-hidden sx={{ mr: 1, flexShrink: 0, fontSize: 19, color: designTokens.color.warning }} />
    <Stack direction="row" spacing={0.75} sx={{ flex: 1, minWidth: 0, alignItems: 'baseline' }}>
      <Typography component="span" noWrap sx={{ flexShrink: 0, color: designTokens.color.primaryText, ...designTokens.typography.ui, fontWeight: 760 }}>{context.label}</Typography>
      {context.description && <Typography component="span" noWrap sx={{ minWidth: 0, color: designTokens.color.secondaryText, ...designTokens.typography.supporting }}>{context.description}</Typography>}
    </Stack>
    <Button disabled={context.actionDisabled} onClick={context.onAction} sx={{ ml: 1, flexShrink: 0, '&:focus-visible': createFocusRingStyles() }}>{context.actionLabel}</Button>
  </Box>;
}
